import { Component, inject } from '@angular/core';
import { CmsOrderDetailOverviewComponent, TranslationService } from '@spartacus/core';
import { OrderDetailsService } from '@spartacus/order/components';
import { Card, CmsComponentData } from '@spartacus/storefront';
import { filter, map, Observable } from 'rxjs';
import { KnBrOrderOverviewComponent } from 'src/feature-libs/kn-br-order/components/kn-br-order-confirmation/kn-br-order-overview/kn-br-order-overview.component';
import { KnBrOrder } from 'src/feature-libs/kn-br-order/root/models/kn-br-order.model';
import { KnBrPricingVisibilityService } from 'src/services/kn-br-pricing-visibility.service';
import { KnBrDateHelper } from 'src/shared/kn-br-date.helper';

@Component({
  selector: 'atg-order-confirmation-overview',
  templateUrl: './atg-order-confirmation-overview.component.html',
  styleUrl: './atg-order-confirmation-overview.component.scss',
  standalone: false,
})
export class AtgOrderConfirmationOverviewComponent extends KnBrOrderOverviewComponent {
  hidePricing$ = inject(KnBrPricingVisibilityService).hidePricing$;

  constructor(
    protected translation: TranslationService,
    orderDetailsService: OrderDetailsService,
    component: CmsComponentData<CmsOrderDetailOverviewComponent>,
    knBrDateHelper: KnBrDateHelper
  ) {
    super(translation, orderDetailsService, component, knBrDateHelper);
  }
  getOrderSpecialInstructions(headerComments: string): Observable<Card> {
    return this.translation.translate('AtgOrderConfirmation.specialInstructions').pipe(
      map(
        (textTitle) =>
          ({
            title: textTitle,
            text: [headerComments],
          } as Card)
      )
    );
  }

 override getDeliveryModeCardContent(order: KnBrOrder): Observable<Card> {
    return this.translation.translate('checkoutOrderConfirmation.shippingMethod').pipe(
      filter(() => Boolean(order.deliveryMode)),
      map(
        (textTitle) =>
          ({
            title: textTitle,
            textBold: order.deliveryMode?.name,
            text: [order.collectNumber && order.deliveryMode?.name !== 'Best Way' ? `Collect #${order.collectNumber}` : ''],
          } as Card)
      )
    );
  }
}
